// | ------------------------------------------------------------------------
// | Project Items
// | ------------------------------------------------------------------------

//? https://github.com/michalsnik/aos
import AOS from "aos";

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {

  var projectItems = document.querySelectorAll(".project-item");

  projectItems.forEach(function (projectItem) {

    var contentHeight = projectItem.querySelector('.project-item-content').offsetHeight + "px";

    projectItem.style.setProperty('--content-height', contentHeight);

  });

});

window.addEventListener("resize", function () {
    
  var projectItems = document.querySelectorAll(".project-item");

  projectItems.forEach(function (projectItem) {

    var contentHeight = projectItem.querySelector('.project-item-content').offsetHeight + "px";

    projectItem.style.setProperty('--content-height', contentHeight);

  });

},true);
